<template>
  <div>

    <div class="protocol">

      <form>

        <div class="row">

          <div class="col-md-4">
            <div class="alert alert-light" role="alert">
              <h1 class="page-title">{{protocol.title}}</h1>
              <dl class="sidebar-list">
                <dt>{{'protocol.area' | trans}}</dt>
                <dd>{{protocol.skillField.name}}</dd>
                <dt>{{'protocol.goal' | trans}}</dt>
                <dd class="pre-line">{{protocol.goal}}</dd>
              </dl>
              <hr>
              <dl class="half-list">
                <dt>{{'protocol.assignDate' | trans}}</dt>
                <dd v-if="assignedProtocol.createdAt">
                  {{assignedProtocol.createdAt.date| toLocaleDate}}
                </dd>
                <dt>{{'protocol.startTraining' | trans}}</dt>
                <dd v-if="assignedProtocol.beginDate">
                  {{assignedProtocol.beginDate.date| toLocaleDate}}
                </dd>
                <dt>{{'protocol.lastLesson' | trans}}</dt>
                <dd v-if="assignedProtocol.endDate">
                  {{assignedProtocol.endDate.date| toLocaleDate}}
                </dd>
              </dl>
            </div>

          </div>

          <div class="col-md-8">

            <toogle-view>
              <dl class="list">
                <dt>{{'protocol.instruction' | trans}}</dt>
                <dd class="pre-line">{{protocol.dataFields.instruction}}</dd>
                <dt>{{'protocol.trueReaction' | trans}}</dt>
                <dd class="pre-line">{{protocol.dataFields.rightReaction}}</dd>
                <dt>{{'protocol.providingHint' | trans}}</dt>
                <dd class="pre-line">{{protocol.dataFields.provideHint}}</dd>
                <dt>{{'protocol.reducingPromp' | trans}}</dt>
                <dd class="pre-line">{{protocol.dataFields.reductionHint}}</dd>
              </dl>
            </toogle-view>

  
            <div  v-if="isPecs() || isPecsWithoutDiscrimination()" v-for="value in protocol.stages"  class="form-group row">
    
              <div class="col-12 mt-3">
      
                <h4 class="row-title" v-if="isPecs()">{{'protocol.pecs.target_sequence_title' | trans}}. {{ value.description | trans }}</h4>
                <h4 class="row-title" v-if="isPecsWithoutDiscrimination()">{{'protocol.pecs.target_sequence_title' | trans}}</h4>

                <table class="table table-sm">
                  <tbody>
                  <tr v-for="(task, index) in value.tasks" :key="task.id" >
                    <td>
                      {{index + 1}}
                    </td>
                    <td class="name-field">
                      {{task.description}}
                    </td>
                  </tr>
                  </tbody>
                </table>
    
              </div>
  
            </div>

            <!----- execution ----->
            <div class="alert alert-secondary">
              <div class="form-group row" v-if="('execution' in this.protocol)">
                <div class="col-md-12">
                  <h4 class="row-title">{{'protocol.execution' | trans}}</h4>
                  <p class="pre-line">{{protocol.execution}}</p>
                </div>
              </div>
            </div>
            <!----- execution ----->

            <!----- execution ----->
            <div class="alert alert-primary">
              <div class="form-group row" v-if="protocol.dataFields.features">
                <div class="col-md-12">
                  <dl class="list">
                    <dt>{{'protocol.features' | trans}}</dt>
                    <dd class="pre-line">{{protocol.dataFields.features}}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <!----- execution ----->

            <toogle-view>

              <dl class="list">
                <dt>{{'protocol.errorCorrection' | trans}}</dt>
                <dd class="pre-line">{{protocol.dataFields.errorCorrection}}</dd>
              </dl>

            </toogle-view>

            <div class="form-group row" v-if="!isMensurationForbidden && !isClient && !isOnIndividualization()">
              <div class="col-md-12">

                <router-link class="btn btn-primary mr-2" v-if="activeProtocolList.length != 1 && !isCompleted() && !isPecs() && !isPecsWithoutDiscrimination() && !isPecsWithDiscrimination()"
                             :to="{ name: 'stage-list', params: { clientId: assignedProtocol.assigneeId, protocolData: protocolData}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>
                <router-link class="btn btn-primary mr-2" v-if="activeProtocolList.length == 1 && !isCompleted() && (isChain() || isShaping() || isMand())"
                             :to="{ name: isChain() ? 'chain-stage-current' : isShaping() ? 'shaping-stage-current' : 'mand-stage-current',
                      params: {clientId: assignedProtocol.assigneeId, protocolId: assignedProtocol.id, stageId:activeProtocolList[0].id}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>
                <router-link class="btn btn-primary mr-2" v-if="isPecsWithDiscrimination()"
                             :to="{ name: 'stage-list', params: { clientId: assignedProtocol.assigneeId, protocolData: protocolData}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>
                <router-link class="btn btn-primary mr-2" v-if="activeProtocolList.length == 1 && !isCompleted() && isUSD()"
                             :to="{ name: 'choose-usd',
                      params: {clientId: assignedProtocol.assigneeId, protocolId: assignedProtocol.id, stageId:activeProtocolList[0].id}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>
                <router-link class="btn btn-primary mr-2" v-if="!isCompleted() && isPecs()"
                             :to="{ name: 'pecs-stage',
                      params: {clientId: assignedProtocol.assigneeId, protocolId: assignedProtocol.id, stageId:protocolData.protocol.stages[0].id}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>
                <router-link class="btn btn-primary mr-2" v-if="!isCompleted() && isPecsWithoutDiscrimination()"
                             :to="{ name: 'pecs-stage-without-discrimination',
                      params: {clientId: assignedProtocol.assigneeId, protocolId: assignedProtocol.id, stageId:protocol.stages[0].id}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>

                <router-link class="btn btn-primary mr-2" v-if="!isCompleted() && isPecsWithItems()"
                             :to="{ name: 'pecs-with-items-stage',
                      params: {clientId: assignedProtocol.assigneeId, protocolId: assignedProtocol.id, stageId:protocol.stages[0].id}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>
                <router-link class="btn btn-primary mr-2"  v-if="activeProtocolList.length == 1 && !isCompleted() && isDtt()"
                             :to="{ name: 'choose-stage',
                      params: {clientId: assignedProtocol.assigneeId, protocolId: assignedProtocol.id, stageId: activeProtocolList[0].id}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>
  
                <router-link class="btn btn-primary mr-2"  v-if="activeProtocolList.length == 1 && !isCompleted() && isSimple()"
                             :to="{ name: 'current-stage',
                     params: {clientId: assignedProtocol.assigneeId, protocolId: assignedProtocol.id, stageId:activeProtocolList[0].id}}">
                  {{'protocol.buttons.goToExercises' | trans}}
                </router-link>

              </div>
            </div>
          </div>
        </div>

      </form>

    </div>
  </div>

</template>

<script>
  import axios from 'axios';
  import ToogleView from '../../../common/toggleView/components/ToggleView';
  import {mapState, mapGetters} from 'vuex';
  import {PROTOCOL_STATUSES, PROTOCOL_TYPE} from '../../protocols/constants.js';
  import filter from 'lodash/filter';

  export default {
    props: ['protocolId', 'protocolData'],

    data() {
      return {
        apiUrl: '/protocols/assigned/',
        statusId: null,
        teachingMethodId:null,
        assignedProtocol: {
          id: null,
          assigneeId: null,
          assignorId: null,
          status: {},
          passedStages: [],
          activeStage: {},
          beginDate: null,
          endDate: null,
        },
        protocol: {
          id: null,
          title: null,
          skillField: null,
          goal: null,
          execution: null,
          dataFields: [],
          published: null,
          createdAt: null,
          updatedAt: null,
          deletedAt: null,
          stages: [],
        },
        dataFields: [
          'code1',
          'code2',
          'features',
          'instruction',
          'provideHint',
          'reductionHint',
          'rightReaction',
          'errorCorrection',
          'templateTitle',
          'taskType',
          'skillField',
          'goal',
          'execution',
        ],

      };
    },

    components: {ToogleView},

    computed: {
      ...mapGetters('auth', [
        'isClient',
        'isMensurationForbidden',
      ]),
      ...mapState([
        'route',
      ]),

      activeProtocolList(){

        let activeList = filter(this.protocolData.protocol.stages, stage => !stage.isClosed);

        return activeList;
      }
    },

    methods: {



      isCompleted: function () {
        return this.statusId === PROTOCOL_STATUSES.COMPLETED;
      },
      isOnIndividualization: function () {
        return this.statusId === PROTOCOL_STATUSES.INDIVIDUALIZATION;
      },
      isDtt: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.DTT;
      },

      isMand: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.MAND;
      },

      isUSD: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.USD;
      },

      isChain: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.CHAIN;
      },
      isShaping: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.SHAPING;
      },

      isSimple: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.SIMPLE;
      },

      isPecs: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.PECS;
      },

      isPecsWithoutDiscrimination: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.PECSDESTINATION;
      },

      isPecsWithItems: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.PECSWITHITEMS;
      },


      isPecsWithDiscrimination: function () {
        return this.teachingMethodId.toString() === PROTOCOL_TYPE.PECSWITHDISCRIMINATION;
      },

      fetchProtocol: async function(id) {
        try {
          if (!this.protocolData){
            let response = await axios.get(this.apiUrl + id + '/info');

            this.protocol = response.data.data.protocol;
            this.assignedProtocol = response.data.data;
            this.statusId = response.data.data.status.id;
          } else{
            this.protocol = this.protocolData.protocol;
            this.assignedProtocol = this.protocolData;
            this.statusId = this.protocolData.status.id;
          }

          this.teachingMethodId = this.protocol.teachingMethod.id;
        } catch (error) {
          console.dir(error);
          this.isClient ?
              this.$router.push({name: 'available-protocols'}) :
              this.$router.push({name: 'client'});
        }
      },

      otherFields: function(key) {
        return !this.dataFields.includes(key);
      },

      loadProtocol: async function() {
        this.isNew = false;
        await this.fetchProtocol(this.protocolId);
      },

    },
    created() {
      this.loadProtocol();

    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/ActiveProtocolView.vue